import { IConfig } from '../config';

/* eslint-disable @typescript-eslint/ban-ts-comment */
export interface ConfigMetadata {
  [index: string]: {
    class: string;
    envVar: string;
    type: string;
  };
}

export interface AppManifest {
  /** View engine framework. Ex: React, Angular, etc. */
  viewEngine: {
    name: string;
    version?: string;
  };
  /** Varáveis de ambiente configuráveis de acordo com cada staging */
  config: IConfig;
  /** Metadada das variáveis de ambiente */
  configMetadata?: ConfigMetadata;
}

export const parse = (json: AppManifest): AppManifest => {
  const toBoolean = (val: object) => String(val).toLocaleLowerCase() === 'true';
  const toNumber = (val: object) => parseFloat(String(val));

  const config: IConfig = {
    ...json.config,
  };

  if (json.configMetadata != null) {
    const { configMetadata } = json;
    Object.keys(configMetadata).forEach((p) => {
      const metadataType = configMetadata[p].type;
      // @ts-ignore
      const configValue = json.config[p];
      if (configValue != null) {
        if (metadataType === 'Boolean') {
          // @ts-ignore
          config[p] = toBoolean(configValue);
        } else if (metadataType === 'Number') {
          // @ts-ignore
          config[p] = toNumber(configValue);
        } else {
          // @ts-ignore
          config[p] = String(configValue);
        }
      }
    });
  }

  return {
    ...json,
    config,
  };
};
